export const createPages_const = 'createPages_const';
export const checkAll_const = 'checkAll_const';
export const checkEmployee_const = 'checkEmployee_const';
export const focusEmployee_const = 'focusEmployee_const';
export const cancelEdit_const = 'cancelEdit_const';
